(function () {
  'use strict';

  var STORAGE_KEY = 'od_marketing_attribution_v1';
  var RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
  var PARAMETER_NAMES = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_content',
    'utm_term',
    'utm_source_platform',
    'meta_adset_id',
    'meta_ad_id',
    'meta_placement'
  ];

  function clean(value, maximumLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maximumLength || 120);
  }

  function marketingProcessingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return true;
    return privacy.marketingAllowed();
  }

  function readStoredAttribution() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!stored || !stored.expiresAt || Date.now() > stored.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return stored;
    } catch (error) {
      return null;
    }
  }

  function writeStoredAttribution(attribution) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {
      return;
    }
  }

  function touchFromCurrentUrl() {
    var parameters = new URLSearchParams(window.location.search);
    var hasMarketingParameter = PARAMETER_NAMES.some(function (name) {
      return parameters.has(name) && clean(parameters.get(name));
    });
    if (!hasMarketingParameter) return null;

    var touch = {
      captured_at: new Date().toISOString(),
      landing_page: clean(window.location.pathname, 180)
    };
    PARAMETER_NAMES.forEach(function (name) {
      var value = clean(parameters.get(name));
      if (value) touch[name] = value;
    });
    return touch;
  }

  function formatTouch(touch) {
    var parts = [];
    if (touch.utm_source || touch.utm_medium) {
      parts.push([touch.utm_source, touch.utm_medium].filter(Boolean).join(' / '));
    }
    if (touch.utm_campaign) {
      parts.push('Campagna: ' + touch.utm_campaign + (touch.utm_id ? ' [' + touch.utm_id + ']' : ''));
    } else if (touch.utm_id) {
      parts.push('ID campagna/flusso: ' + touch.utm_id);
    }
    if (touch.utm_content) parts.push('Inserzione/email: ' + touch.utm_content);
    if (touch.utm_term) parts.push('Gruppo inserzioni: ' + touch.utm_term);
    if (touch.meta_ad_id) parts.push('Ad ID: ' + touch.meta_ad_id);
    if (touch.meta_adset_id) parts.push('Ad set ID: ' + touch.meta_adset_id);
    if (touch.meta_placement) parts.push('Posizionamento: ' + touch.meta_placement);
    if (touch.utm_source_platform) parts.push('Piattaforma: ' + touch.utm_source_platform);
    return clean(parts.join(' | '), 500);
  }

  function cartAttributes(attribution) {
    return {
      'Attribuzione - primo contatto': formatTouch(attribution.first),
      'Attribuzione - ultimo contatto': formatTouch(attribution.last),
      'Pagina ingresso - primo contatto': attribution.first.landing_page,
      'Pagina ingresso - ultimo contatto': attribution.last.landing_page,
      'Data - primo contatto': attribution.first.captured_at,
      'Data - ultimo contatto': attribution.last.captured_at
    };
  }

  function attributesDiffer(current, expected) {
    return Object.keys(expected).some(function (key) {
      return current[key] !== expected[key];
    });
  }

  function syncCart(attribution) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var expected = cartAttributes(attribution);
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!attributesDiffer(cart.attributes || {}, expected)) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: expected })
        });
      })
      .catch(function () { return null; });
  }

  function captureAndSync() {
    if (!marketingProcessingAllowed()) return;

    var currentTouch = touchFromCurrentUrl();
    var attribution = readStoredAttribution();
    if (currentTouch) {
      attribution = attribution || { first: currentTouch };
      attribution.last = currentTouch;
      attribution.expiresAt = Date.now() + RETENTION_MS;
      writeStoredAttribution(attribution);
    }
    if (attribution && attribution.first && attribution.last) syncCart(attribution);
  }

  function initialize() {
    document.addEventListener('visitorConsentCollected', captureAndSync);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { captureAndSync(); }
      );
    } else {
      captureAndSync();
    }
  }

  initialize();
})();
